export default {"src":"/_next/static/media/positionOpposition.eb24c9df.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};